var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 8.00001C14.4001 9.69739 13.7258 11.3253 12.5256 12.5255C11.3253 13.7257 9.69748 14.4 8.0001 14.4C6.30271 14.4 4.67485 13.7257 3.47461 12.5255C2.27438 11.3253 1.6001 9.69739 1.6001 8.00001C1.6001 6.30262 2.27438 4.67476 3.47461 3.47452C4.67485 2.27429 6.30271 1.60001 8.0001 1.60001C9.69748 1.60001 11.3253 2.27429 12.5256 3.47452C13.7258 4.67476 14.4001 6.30262 14.4001 8.00001ZM9.6001 5.60001C9.6001 6.02435 9.43153 6.43132 9.13147 6.73138C8.83141 7.03144 8.42444 7.20001 8.0001 7.20001C7.57575 7.20001 7.16879 7.03144 6.86873 6.73138C6.56867 6.43132 6.4001 6.02435 6.4001 5.60001C6.4001 5.17566 6.56867 4.76869 6.86873 4.46864C7.16879 4.16858 7.57575 4.00001 8.0001 4.00001C8.42444 4.00001 8.83141 4.16858 9.13147 4.46864C9.43153 4.76869 9.6001 5.17566 9.6001 5.60001ZM8.0001 8.80001C7.23418 8.79985 6.48432 9.0196 5.83963 9.43313C5.19494 9.84666 4.68253 10.4366 4.3633 11.1328C4.81344 11.6565 5.37151 12.0766 5.99925 12.3644C6.62699 12.6522 7.30954 12.8008 8.0001 12.8C8.69065 12.8008 9.3732 12.6522 10.0009 12.3644C10.6287 12.0766 11.1868 11.6565 11.6369 11.1328C11.3177 10.4366 10.8053 9.84666 10.1606 9.43313C9.51588 9.0196 8.76602 8.79985 8.0001 8.80001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/UserCircle.a886bfd83503cd23d8b22ab521788474.svg";
export { ForwardRef as ReactComponent };